import { useEffect, useState } from "react";
import { useNetworkCheck } from "./networkProvider";
import { showToast } from "./utils";
import { showToastType } from "./constants/appConstants";
import { invcsConnect } from "../locales/en";

const NetworkStatus = () => {
  const { isOnline } = useNetworkCheck();
  const [prevIsOnline, setPrevIsOnline] = useState(isOnline);

  useEffect(() => {
    if (isOnline !== prevIsOnline) {
      if (!isOnline) {
        showToast(invcsConnect?.netWorkStatus.noNetwork, showToastType.error);
      } else {
        showToast(
          invcsConnect?.netWorkStatus.backOnline,
          showToastType.success
        );
      }
      setPrevIsOnline(isOnline);
    }
  }, [isOnline, prevIsOnline]);
};

export default NetworkStatus;
